<template>
  <div class="container">
    <el-row style="margin-bottom: 10px">
      <el-col :span="12" style="color: #3a6ea5">
        <span style="margin-right: 20px">
          项目ID:{{ project_id }}
        </span>
        <span>
          项目名称：{{ project_name }}
        </span>
      </el-col>
    </el-row>
    <!--搜索-->
    <div class="section-container">
      <search-filter :form-config="searchConfig" :model="query" @search="search" @reset="reset"></search-filter>
    </div>
    <!--操作-->
    <div class="button-container">
      <el-button v-if="this.is_admin" type="primary" plain size="small" round @click="handleAdd">新增项目人员</el-button>
      <el-button v-if="this.is_admin" type="primary" plain size="small" round
        @click="handleProjectGroup">查看项目组统计</el-button>
    </div>
    <!--列表-->
    <el-table :loading="loading" :data="tableData"  border stripe style="width: 100%;border-radius: 10px;">
      <el-table-column border label="人员名称" prop="employee_name"></el-table-column>
      <el-table-column border label="项目角色" prop="project_role"></el-table-column>
      <el-table-column border label="所属项目组" prop="project_group"></el-table-column>
      <el-table-column border label="工作量（截止到昨天）" prop="workload"></el-table-column>
      <el-table-column border label="联系方式" prop="mobile"></el-table-column>
      <el-table-column v-if="is_admin" border label="操作" min-width="120" fixed="right">
        <template v-slot="scope">
          <el-button v-if="is_admin" type="primary" size="mini" plain @click="handleEdit(scope.row)">编辑</el-button>
          <el-button v-if="is_admin" type="danger" size="mini" plain @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination style="margin-top:25px" @size-change="changePageSize" @current-change="changePage"
      :current-page.sync="pagination.current_page" :page-size="pagination.per_page"
      layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
    <!--对话框-->
    <el-dialog title="新增项目人员" :visible.sync="addModel.addShow" width="600px" @close="onAddClose">
      <el-form ref="addForm" :model="addModel" label-width="80px" size="small">
        <el-form-item label="人员">
          <el-select v-model="addModel.project_employee_ids" multiple filterable default-first-option
            placeholder="请选择参加项目的人员" style="width: 100%">
            <el-option v-for="item in employee_options" :key="item.value" :label="item.label" :value="item.value">
              <span style="float: left">{{ item.label }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目角色">
          <el-select v-model="addModel.project_role" clearable style="margin-top:10px;width: 100%"
            placeholder="请选择项目角色">
            <el-option label="主检" value="主检"></el-option>
            <el-option label="记录员" value="记录员"></el-option>
            <el-option label="网格员" value="网格员"></el-option>
            <el-option label="告知书联系人" value="告知书联系人"></el-option>
            <el-option label="项目观察员" value="项目观察员"></el-option>
            <el-option label="审核人" value="审核人"></el-option>
            <el-option label="审批人" value="审批人"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目组">
          <el-input placeholder="按项目组统计需要填写，不统计留空"></el-input>
          <el-form-item style="margin-left:120px;margin-top: 30px">
            <el-button type="primary" @click="onAdd">新增</el-button>
            <el-button type="info" @click="onAddClose">取消</el-button>
          </el-form-item>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--编辑对话框-->
    <el-dialog title="编辑项目人员" :visible.sync="editModel.editShow" width="600px" @close="onEditClose">
      <el-form ref="editForm" :model="editModel" label-width="80px" size="small">
        <el-form-item label="人员ID">
          <el-input v-model="editModel.id" disabled></el-input>
        </el-form-item>
        <el-form-item label="人员名称">
          <el-input v-model="editModel.employee_name" placeholder="人员名称" disabled></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="editModel.mobile" placeholder="联系方式" disabled></el-input>
        </el-form-item>
        <el-form-item label="默认角色">
          <el-select v-model="editModel.project_role">
            <el-option v-for="item in project_roles" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目组">
          <el-input v-model="editModel.project_group" placeholder="按项目组统计可填写，单项目组无需填写"></el-input>
        </el-form-item>
        <el-form-item style="margin-left:80px;margin-top: 30px">
          <el-button type="primary" @click="onEdit">编辑</el-button>
          <el-button type="info" @click="onEditClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--按照项目组统计-->
    <el-dialog title="按项目组统计工作量" :visible.sync="groupModel.groupShow" width="600px" @close="onEditClose">
      <el-table :data="groupData" style="width:100%">
        <el-table-column prop="project_group" label="项目组"></el-table-column>
        <el-table-column prop="project_group_workload" label="工作量"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>

export default {
  data() {
    return {
      loading: false,
      currentConfig: {},
      project_id: '',
      project_name: '',
      tableData: [],
      groupData: [],
      is_admin: false,
      project_roles: [
        { text: "主检", value: "主检" },
        { text: "记录员", value: "记录员" },
        { text: "网格员", value: "网格员" },
        { text: "告知书联系人", value: "告知书联系人" },
        { text: "项目观察员", value: "项目观察员" },
        { text: "审核人", value: "审核人" },
        { text: "审批人", value: "审批人" }
      ],
      pagination: { current_page: 1, total: 1, per_page: 10, },
      query: { employee_name2: "", project_role: "" },
      searchConfig: [
        { key: "employee_name2", label: "人员名称", type: "input" },
        {
          key: "project_role", label: "项目角色", type: "select",
          list: this.project_roles
        },
      ],
      employee_options: [],
      addModel: {
        addShow: false,
        project_employee_ids: '',
        project_role: '',
        project_group: '',
      },
      editModel: {
        editShow: false,
        id: '',
        project_role: '',
        project_group: '',
      },
      groupModel: {
        groupShow: false,
      },
    };
  },
  methods: {
    //初始化对话框
    initModel(model) {
      Object.keys(model).forEach(key => {
        if (key === 'addShow' || key === 'editShow') {
          model[key] = false
        } else {
          model[key] = ''
        }
      })
    },
    //新增
    handleAdd() {
      this.addModel.addShow = true
    },
    async onAdd() {
      try {
        if (this.addModel.project_role.length === 0) {
          this.$message.error("请选择人员角色")
          return
        }
        await this.$Api.post('add_project_employee', {
          project_id: this.project_id,
          employee_ids: this.addModel.project_employee_ids.join(","),
          project_role: this.addModel.project_role
        })
        this.$message.success('新增成功')
        this.initModel(this.addModel)
        await this.getList()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    onAddClose() {
      this.initModel(this.addModel)
    },
    //编辑
    handleEdit(row) {
      this.editModel.editShow = true
      this.editModel.id = row.id
      this.editModel.employee_name = row.employee_name
      this.editModel.mobile = row.mobile
      this.editModel.project_role = row.project_role
      this.editModel.project_group = row.project_group
    },
    async onEdit() {
      try {
        await this.$Api.post('edit_project_employee', {
          id: this.editModel.id,
          project_role: this.editModel.project_role,
          project_group: this.editModel.project_group
        })
        this.$message.success('编辑成功')
        this.initModel(this.editModel)
        await this.getList()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    onEditClose() {
      this.initModel(this.editModel)
    },
    async handleProjectGroup() {
      this.groupModel.groupShow = true
      try {
        let res = await this.$Api.post('get_project_group_workload', { project_id: this.project_id })
        if (res) {
          this.groupData = res
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    handleDelete(row) {
      this.$confirm('确认删除?', '确认删除', {
        confirmButtonClass: '确认',
        cancelButtonClass: '取消',
        type: 'warning'
      }).then(
        async () => {
          try {
            await this.$Api.post('del_project_employee', { 'id': row.id })
            this.$message.success('删除成功')
            await this.getList()
          } catch (e) {
            this.$message.error(e.errormsg)
          }
        }
      )
    },
    changePage() {
      this.getList();
    },
    changePageSize(size) {
      this.pagination.per_page = size;
      this.getList();
    },
    search() {
      this.getList();
    },
    reset() {
      this.query = {
        employee_name2: "",
        account: "",
        mobile: "",
      };
      this.pagination.current_page = 1;
      this.pagination.total = 1;
      this.getList();
    },
    async getList() {
      try {
        this.loading = true;
        let params = {
          ...this.query,
          ...this.pagination,
        };
        params.project_id = this.project_id
        let data = await this.$Api.post("get_project_employee", params);
        this.pagination = {
          current_page: data.current_page,
          total: data.total,
          per_page: data.per_page
        }
        this.tableData = data.data;
        this.loading = false;
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //获取人员下拉
    async getEmployeeOptions() {
      try {
        this.employee_options = await this.$Api.get('sys_employee_options', { project_id: this.project_id })
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    async getProject() {
      try {
        let res = await this.$Api.post('get_project', { project_id: this.project_id })
        if (res) {
          this.project_name = res.project_name
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    async getProjectRole() {
      try {
        let res = await this.$Api.post('get_project_role', { project_id: this.project_id })
        if (res) {
          if (res.is_admin) {
            this.is_admin = true
          }
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    }
  },
  created() {
    this.project_id = this.$route.params.project_id
    this.getProject()
    this.getProjectRole()
    this.getList();
    this.getEmployeeOptions()
  },
};
</script>
<style scoped>
.el-col {
  color: var(--primary-color);
}

.section-container {
  margin-bottom: 16px;
}

.button-container {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
}

:deep(.el-table th) {
  background-color: var(--primary-color) !important;
  color: var(--text-on-primary) !important;
}

.el-pagination {
  margin-top: 20px;
  text-align: center;
}
</style>